var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bim-select',{attrs:{"value":_vm.lang,"options":[
    {
      value: 'ru',
      label: 'RUS'
    },
    {
      value: 'en',
      label: 'EN'
    }
  ]},on:{"change":_vm.changeLang}})}
var staticRenderFns = []

export { render, staticRenderFns }